// @ts-nocheck

import { get } from 'lodash'
import * as Sentry from '@sentry/react'
import {
  getSpotifyTrack as onGetSpotifyTrack,
  getSpotifyTracks as onGetSpotifyTracks,
  setTracksToInitialState,
} from 'Redux/actions/trackActions'
import { getFreeSpotifyAccessToken } from 'Redux/actions/spotifyTokenActions'
import { Track } from 'Types/index'
import { checkTrackToCreateCampaign as onCheckTrack } from '../../../../Redux/actions/campaignActions'

interface findTrackHandlerParamsType {
  searchText: string
  accessToken: string
  setIsSearch: (value: boolean) => void
  setErrorText: (value: string) => void
  setTracksToInit: () => void
  dispatch
}

export const findTrackHandler = ({
  searchText,
  setIsSearch,
  dispatch,
  accessToken,
  setErrorText,
  setTracksToInit,
}: findTrackHandlerParamsType) => {
  setIsSearch(true)
  if (searchText.includes('%')) {
    setErrorText('createCampaignPage.trackCouldNotBeFound')
  } else if (searchText.includes('open.spotify.com')) {
    const trackID = searchText.split('/').slice(-1)
    const url = `https://api.spotify.com/v1/tracks/${trackID}`
    dispatch(
      onGetSpotifyTracks(url, accessToken, error => {
        if (error as Error) {
          setIsSearch(false)
          setTracksToInit()
          Sentry.captureException({
            errorMessage: error.error.message || '',
            searchText,
          })
          if (error.error.message === 'The access token expired') {
            dispatch(
              getFreeSpotifyAccessToken((err, res) => {
                dispatch(
                  onGetSpotifyTracks(url, res.access_token, (error, res) => {
                    setTracksToInit()
                    if (error as Error) {
                      error.message === 'The access token expired'
                        ? setErrorText(error.message)
                        : setErrorText('createCampaignPage.somethingWentWrong')
                      setIsSearch(false)
                    } else if (res.tracks.items.length === 0) {
                      setErrorText('createCampaignPage.trackCouldNotBeFound')
                    }
                    setIsSearch(false)
                  })
                )
              })
            )
          } else {
            setErrorText('createCampaignPage.trackCouldNotBeFound')
            setIsSearch(false)
          }
        } else {
          localStorage.trackURL = url
          setIsSearch(false)
        }
      })
    )
  } else {
    const url = `https://api.spotify.com/v1/search?q=${searchText}&type=artist,track`
    dispatch(
      onGetSpotifyTracks(url, accessToken, (error, res) => {
        setTracksToInit()
        if (error as Error) {
          Sentry.captureException({
            errorMessage: error.error.message || '',
            searchText,
          })
          if (error.error.message === 'The access token expired') {
            dispatch(
              getFreeSpotifyAccessToken((err, res) => {
                dispatch(
                  onGetSpotifyTracks(url, res.access_token, (error, res) => {
                    setTracksToInit()
                    if (error as Error) {
                      error.message === 'The access token expired'
                        ? setErrorText(error.message)
                        : setErrorText('createCampaignPage.somethingWentWrong')
                      setIsSearch(false)
                    } else if (res.tracks.items.length === 0) {
                      setErrorText('createCampaignPage.trackCouldNotBeFound')
                    }
                    setIsSearch(false)
                  })
                )
              })
            )
          } else {
            setErrorText('createCampaignPage.trackCouldNotBeFound')
            setIsSearch(false)
          }
        } else if (res.tracks.items.length === 0) {
          setErrorText('createCampaignPage.trackCouldNotBeFound')
        }
        setIsSearch(false)
      })
    )
  }
}

export interface addHandlerParamsType {
  apiURL: string
  accessToken: string
  isAuth: boolean
  setIsChangedTrack: (v: boolean) => void
  setErrorText: (v: string) => void
  setGTMevent: (v: Track) => void
  handleSetSearchToInitial: () => void
  dispatch
}

export const addHandler = ({
  apiURL,
  accessToken,
  isAuth,
  dispatch,
  setIsChangedTrack,
  setErrorText,
  setGTMevent,
  handleSetSearchToInitial,
}: addHandlerParamsType) => {
  if (accessToken) {
    if (isAuth) {
      dispatch(
        onCheckTrack(apiURL, error => {
          if (!error) {
            setIsChangedTrack(false)
            dispatch(
              onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
                if (error) {
                  const errorMessage = get(error, 'error.message', null)
                  if (errorMessage === 'The access token expired') {
                    setErrorText('The access token expired')
                  } else {
                    setErrorText(
                      'createCampaignPage.sorrySpotifyIsNotRespondingPleaseTryAgainLater'
                    )
                  }
                } else {
                  setGTMevent(res)
                  localStorage.setItem('trackURL', apiURL)
                }
              })
            )
            handleSetSearchToInitial()
          } else {
            setErrorText('createCampaignPage.sameTrackError')
            dispatch(setTracksToInitialState())
          }
        })
      )
    } else {
      dispatch(
        onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
          if (error) {
            const errorMessage = get(error, 'error.message', null)
            if (errorMessage === 'The access token expired') {
              setErrorText('The access token expired')
            } else {
              setErrorText(
                'createCampaignPage.sorrySpotifyIsNotRespondingPleaseTryAgainLater'
              )
            }
          } else {
            setIsChangedTrack(false)
            setGTMevent(res)
            localStorage.setItem('trackURL', apiURL)
          }
        })
      )
      handleSetSearchToInitial()
    }
  }
}
